import { render, staticRenderFns } from "./systermAuthorTwo.vue?vue&type=template&id=14d737d7&scoped=true&"
import script from "./systermAuthorTwo.vue?vue&type=script&lang=js&"
export * from "./systermAuthorTwo.vue?vue&type=script&lang=js&"
import style0 from "./systermAuthorTwo.vue?vue&type=style&index=0&id=14d737d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d737d7",
  null
  
)

export default component.exports